import { Analytics, getAnalytics, logEvent, setAnalyticsCollectionEnabled, setDefaultEventParameters, setUserId, setUserProperties } from "firebase/analytics";
import { inject, injectable } from "inversify";
import { IFirebaseService } from "../firebase/IFirebaseService";
import type { IAnalyticsService } from "./IAnalyticsService";
import { serviceIdentifiers } from "../../container-service-identifiers";

@injectable()
export class FirebaseAnalyticsService implements IAnalyticsService {
    private analytics: Analytics;

    constructor(@inject(serviceIdentifiers.IFirebaseService) firebaseService: IFirebaseService) {
        this.analytics = getAnalytics(firebaseService.appInstance);
    }

    public setCollectionEnabled(enabled: boolean) {
        setAnalyticsCollectionEnabled(this.analytics, enabled);
    }

    public trackEvent(eventType: string, eventParams?: { [key: string]: any; }) {
        logEvent(this.analytics, eventType, eventParams);
    }

    public setUserProperties(properties: { [key: string]: any; }) {
        const reservedKeys = ["age", "gender", "interest"];
        const hasReservedKey = Object.keys(properties).some((key) => reservedKeys.includes(key));
        if (hasReservedKey) {
            console.error(`The properties object contains reserved keys: ${reservedKeys.join(", ")}! Current reserved keys: ${reservedKeys.join(", ")}`);
            throw new Error("Reserved keys in user properties");
        }

        setUserProperties(this.analytics, properties);
    }

    public setUserId(userId: string | null) {
        setUserId(this.analytics, userId);
    }
}